import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
} from "@/components/ui/table";
import { QuoteDiscountLine, type CurrencyCode } from "@forgepoint/shared";
import type { QuoteCurrencyFields } from "@/lib/quoteCurrency";
import { DiscountRow } from "./rows/DiscountRow";

interface QuoteDiscountsTableProps {
  lines: QuoteDiscountLine[];
  readOnly: boolean;
  currencyCode?: CurrencyCode;
  /** Quote currency context; AMOUNT values are entered in the display currency. */
  currencyContext?: QuoteCurrencyFields;
  onUpdateLine: (index: number, line: QuoteDiscountLine) => void;
  onRemoveLine: (index: number) => void;
}

export function QuoteDiscountsTable({
  lines,
  readOnly,
  currencyCode,
  currencyContext,
  onUpdateLine,
  onRemoveLine,
}: QuoteDiscountsTableProps) {
  return (
    <Table className="table-fixed">
      <colgroup>
        <col /> {/* Description - takes remaining space */}
        <col className="w-24 sm:w-36" /> {/* Type */}
        <col className="w-20 sm:w-32" /> {/* Value */}
        <col className="w-12 sm:w-16" /> {/* Actions */}
      </colgroup>
      <TableHeader>
        <TableRow>
          <TableHead className="text-xs sm:text-sm">Description</TableHead>
          <TableHead className="text-xs sm:text-sm">Type</TableHead>
          <TableHead className="text-right text-xs sm:text-sm">Value</TableHead>
          <TableHead /> {/* Actions */}
        </TableRow>
      </TableHeader>
      <TableBody>
        {lines.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={4}
              className="text-center py-8 text-muted-foreground"
            >
              No discounts applied.
            </TableCell>
          </TableRow>
        ) : (
          lines.map((line, index) => (
            <DiscountRow
              key={`discount-${index}`}
              line={line}
              readOnly={readOnly}
              currencyCode={currencyCode}
              currencyContext={currencyContext}
              onUpdate={(updated) => onUpdateLine(index, updated)}
              onRemove={() => onRemoveLine(index)}
            />
          ))
        )}
      </TableBody>
    </Table>
  );
}
